module.exports = __webpack_public_path__ + "static/media/WHO-EN-C-H.92cca4d5.png";